export default "__VITE_ASSET__Co7w33QN__"